import type { ApolloCache } from "@apollo/client";
import useBypass404Store from "src/stores/useBypass404Store";
import GatheringRefCodeFragmentFragmentDoc from "./__generated__/documents/GatheringRefCodeFragmentFragmentDoc";

const evictGathering = (
	cache: ApolloCache<any>,
	gatheringId: string,
	{
		delay,
	}: {
		/**
		 * You probably want a delay to avoid things trying to refetch the deleted data
		 */
		delay?: number;
	} = {},
) => {
	const handleEvict = () => {
		const gathering = cache.readFragment({
			fragment: GatheringRefCodeFragmentFragmentDoc,
			id: cache.identify({
				__typename: "Gathering",
				gatheringId,
			}),
		});
		const { addGatheringIdentifier } = useBypass404Store.getState();
		addGatheringIdentifier(gatheringId);
		if (gathering?.refCode) {
			addGatheringIdentifier(gathering.refCode);
		}
		cache.evict({
			id: cache.identify({
				__typename: "Gathering",
				gatheringId,
			}),
		});
	};
	if (delay) {
		setTimeout(handleEvict, delay);
	} else {
		handleEvict();
	}
};
export default evictGathering;
